export class AsyncQueue {
    buffer = [];
    capacity;
    consumerWaiter = null;
    failure = null;
    isClosed = false;
    producerWaiter = null;
    constructor({ capacity }) {
        this.capacity = capacity;
    }
    close() {
        this.isClosed = true;
        this.wakeConsumer();
        this.wakeProducer();
    }
    fail(error) {
        this.failure = { error };
        this.isClosed = true;
        this.wakeConsumer();
        this.wakeProducer();
    }
    async push(item) {
        while (!this.isClosed && this.buffer.length >= this.capacity) {
            this.producerWaiter ??= Promise.withResolvers();
            await this.producerWaiter.promise;
        }
        if (this.isClosed) {
            return;
        }
        this.buffer.push({ item });
        this.wakeConsumer();
    }
    async *[Symbol.asyncIterator]() {
        while (true) {
            if (this.failure) {
                throw this.failure.error;
            }
            const next = this.buffer.shift();
            if (!next) {
                if (this.isClosed) {
                    return;
                }
                this.consumerWaiter ??= Promise.withResolvers();
                await this.consumerWaiter.promise;
                continue;
            }
            this.wakeProducer();
            yield next.item;
        }
    }
    wakeConsumer() {
        this.consumerWaiter?.resolve();
        this.consumerWaiter = null;
    }
    wakeProducer() {
        this.producerWaiter?.resolve();
        this.producerWaiter = null;
    }
}
